import React, { PropsWithChildren } from 'react';
import deepmerge from 'deepmerge';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import {
    createTheme,
    StyledEngineProvider,
    Theme,
    ThemeProvider as MuiThemeProvider,
} from '@mui/material';

import { muiTheme as defaultMuiTheme } from '@modules/ui/theme';
import { GlobalStyles } from './styled-theme';

type ThemeProviderProps = {
    theme?: Record<string, any>;
} & PropsWithChildren;

const ThemeProvider = ({ theme, children }: ThemeProviderProps): React.ReactElement => {
    const mergedTheme = theme ? deepmerge(defaultMuiTheme, theme) : defaultMuiTheme;
    const muiTheme = createTheme(mergedTheme, {});

    return (
        <StyledEngineProvider injectFirst>
            <GlobalStyles theme={muiTheme} />
            <MuiThemeProvider<Omit<Theme, 'shadows'>> theme={muiTheme}>
                <StyledThemeProvider theme={muiTheme}>{children}</StyledThemeProvider>
            </MuiThemeProvider>
        </StyledEngineProvider>
    );
};

export { ThemeProvider };
